import { FormType } from "@simplyk/common";

import { Translate } from "../../../hooks/useTranslate";

export const getEmailText = ({
  paymentMethodIsAchOrPad,
  email,
  formType,
  t,
  isAuction,
  generateTaxReceipt,
  generateETicket,
}: {
  paymentMethodIsAchOrPad: boolean;
  email: string | null;
  formType: FormType | null;
  t: Translate;
  isAuction: boolean;
  generateTaxReceipt: string | null;
  generateETicket: string | null;
}) => {
  if (paymentMethodIsAchOrPad) {
    return t("common", "thankyouPage.ach.emailDisclaimer", { email });
  }
  if (formType === FormType.DonationForm) {
    if (generateTaxReceipt === "true") {
      return t("common", "thankyouPage.donation.emailDisclaimer.taxReceipt");
    } else {
      return t("common", "thankyouPage.donation.emailDisclaimer.noTaxReceipt");
    }
  } else {
    if (isAuction) {
      return t("common", "thankyouPage.ticketing.emailDisclaimer.bidLinkByEmail");
    } else if (generateETicket === "true") {
      return t("common", "thankyouPage.ticketing.emailDisclaimer.eticket");
    } else if (generateTaxReceipt === "true") {
      return t("common", "thankyouPage.ticketing.emailDisclaimer.taxReceipt");
    } else {
      return t("common", "thankyouPage.ticketing.emailDisclaimer.noTaxReceipt");
    }
  }
};
